import { DeleteOutlined } from "@ant-design/icons"
import { notification, UploadProps, Upload, Image } from "antd"
import React, { useState } from "react"
import styled from "styled-components"
import { Error } from "../TextEditor"

interface IUploadProps {
  labelText: string
  borderColor?: string
  labelColor?: string
  height?: string
}

const Container = styled.div<any>`
  margin-bottom: 20px;
  .label {
    font-weight: 500;
    font-size: 1rem;
    color: ${(props: IUploadProps | any) =>
      props.labelColor ? props.labelColor : props.theme.baseTextColor};
  }
  .ant-upload-select {
    background-color: #202534;
    padding: 16px;
    border: 1px
      ${(props: IUploadProps) =>
        props.borderColor
          ? `dashed ${props.borderColor}`
          : "dashed"} !important;
    border-radius: 5px;
  }
  .ant-upload {
    height: ${(props: IUploadProps) => (props.height ? props.height : "172px")};
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .ant-upload.ant-upload-drag {
    border: none;
  }

  .ant-upload-drag-icon {
    margin-bottom: 16px;
  }
  .ant-upload-drag-icon .anticon {
    svg {
      font-size: 3rem;
      fill: ${(props) => props.theme.indicatorGradient};
    }
  }
  .ant-upload-text {
    margin-bottom: 4px;
    color: #d9d9d9;
    font-weight: 500;
    font-size: 1rem;
    line-height: 24px;
  }

  .ant-upload-hint {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
    color: ${(props) => props.theme.textDisabled};
    margin-bottom: 13px;
  }
  .ant-upload-drag p.ant-upload-text {
    color: ${(props) => props.theme.borderColorBase};
  }

  .ant-upload-drag p.ant-upload-hint {
    color: ${(props) => props.theme.whiteAlpha60};
  }

  .image-component {
    position: relative;
    height: 62px;
    margin-top: 8px;
    padding: 8px;
    border: 1px solid #424242;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .image {
      width: 44px;
      height: 44px;
      margin-right: 10px;
    }
    .delete-icon {
      position: absolute;
      right: 20px;
    }
  }
`

const UploadComponent: React.FC<any> = ({
  labelText,
  handleChange,
  setLoading,
  setImgUploadError,
  setUploading,
  error,
  defaultImage,
  removeImage,
  borderColor,
}) => {
  const [imageFile, setImageFile] = useState<any>(null)

  const imageToBeRendered = JSON.stringify(defaultImage)?.includes("http")
    ? defaultImage
    : ""

  const errorMessage =
    "Please upload an image having size less than or equal 5MB."

  const handleUpload = async ({ file, onSuccess, onError }: any) => {
    setImgUploadError?.(false)
    try {
      onSuccess?.("ok")
      handleChange?.(file)
    } catch (err: any) {
      onError?.(err)
    } finally {
      setUploading?.(false)
      setLoading?.(false)
    }
  }

  const beforeUpload = (file) => {
    const isLessThan5MB = file.size / 1024 / 1024 <= 5
    if (!isLessThan5MB) {
      notification.error({ message: errorMessage, key: "image" })
      setImgUploadError(true)
      return false
    }
    return isLessThan5MB
  }

  const componentProps: UploadProps = {
    name: "image",
    maxCount: 1,
    listType: "picture",
    accept: "image/png, image/jpeg, image/jpg",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    customRequest: handleUpload,
    onChange: (info) => {
      localStorage.setItem(
        "image",
        `${URL?.createObjectURL(info?.fileList?.[0]?.originFileObj)},,${
          info?.fileList?.[0]?.originFileObj?.name
        }`
      )
      setImageFile(info?.fileList)
    },
    beforeUpload: beforeUpload,
    showUploadList: false,
  }

  return (
    <Container borderColor={borderColor}>
      <span className="label">{labelText}</span>
      <Upload {...componentProps}>
        <p className="ant-upload-drag-icon">
          <Image
            src={"/assets/icons/InboxOutlined.svg"}
            height={48}
            width={48}
            alt="inbox-outlined"
          />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single upload. Strictly prohibited from uploading
          company data or other banned files.
        </p>
      </Upload>

      {imageToBeRendered || imageFile?.length ? (
        <div className="image-component">
          <Image
            src={
              imageToBeRendered
                ? imageToBeRendered
                : URL?.createObjectURL(imageFile?.[0]?.originFileObj)
            }
            className="image"
          />
          <p>
            {imageToBeRendered
              ? defaultImage?.match(/cover_image\/(.*?)\?X-Goog/i)?.[1] ||
                localStorage.getItem("image")?.split(",,")?.[1] ||
                "124235345246436.png"
              : imageFile?.[0]?.name}
          </p>
          <div
            className="delete-icon"
            onClick={() => {
              setImageFile(null)
              localStorage.removeItem("image")
              removeImage()
            }}
          >
            <DeleteOutlined />
          </div>
        </div>
      ) : null}
      {error && <Error>{error}</Error>}
    </Container>
  )
}

export { UploadComponent }
